import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import styles from './style.css';

class SubSidebar extends React.Component {
  render() {
    const {
      location,
      user,
      links,
      mokapayMode,
      onLockedItemClick,
      canVisitFacebookOnlineStore,
      canVisitGoogleOnlineStore,
    } = this.props;
    const path = location.pathname;
    const {
      business: { is_kyb_registration_completed: isKybCompleted },
    } = user;
    return (
      <ul className="dropdown-menu" role="menu">
        {links.map((link, index) => {
          const { label, href, urls, isLocked } = link;
          const lowerCasedLabel = label.toLowerCase();

          if (
            (lowerCasedLabel === 'google shopping' &&
              !canVisitGoogleOnlineStore) ||
            (lowerCasedLabel === 'facebook & instagram shop' &&
              !canVisitFacebookOnlineStore)
          ) {
            return null;
          }

          if (mokapayMode && isLocked) {
            return (
              <li key={index} className="disabled">
                <a className="has-icon" onClick={onLockedItemClick}>
                  <i className="glyphicon glyphicon-lock" />
                  &nbsp;
                  {label}
                </a>
              </li>
            );
          }

          const showRedDot = this.props.redDotSubMenus.includes(label);
          const isShowNotification =
            (label === 'Payment Method' ||
              href === '/settings/payment_methods') &&
            isKybCompleted === false;
          return (
            <li key={index}>
              {this._isUrl(href) ? (
                <a href={href} className={urls.includes(path) ? 'active' : ''}>
                  {label}
                  {showRedDot ? <span className="menu-red-dot" /> : ''}
                </a>
              ) : (
                <Link to={href} className={urls.includes(path) ? 'active' : ''}>
                  {label}
                  {showRedDot ? <span className="menu-red-dot" /> : ''}
                  {isShowNotification ? (
                    <span className={`${styles.box_notification}`}>1</span>
                  ) : (
                    ''
                  )}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    );
  }

  _isUrl = url => {
    return url.indexOf('http') >= 0;
  };
}

SubSidebar.propTypes = {
  mokapayMode: PropTypes.bool,
  showRedDot: PropTypes.bool,
  redDotSubMenus: PropTypes.array,
  onLockedItemClick: PropTypes.func,
};

SubSidebar.defaultProps = {
  mokapayMode: false,
  showRedDot: false,
  redDotSubMenus: [],
  onLockedItemClick: () => {},
};

export default SubSidebar;
